import { useRouter, useRoute } from "vue-router";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useProgressBarActions from "@/composables/progress/useProgressBarActions";
import usePaymentEndpoints from "@/composables/api/usePaymentEndpoints";

import DepositView from "../views/DepositView.vue";
import ErrorView from "../views/ErrorView.vue";
import OrderSummaryView from "../views/OrderSummaryView.vue";
import OrderView from "../views/OrderView.vue";
import PaymentView from "../views/PaymentView.vue";
import VerificationCodeView from "../views/VerificationCodeView.vue";
import VerificationView from "../views/VerificationView.vue";
import WidgetView from "../views/WidgetView.vue";
import CoinDepositView from "../views/CoinDepositView.vue";

const { updateToComplete, updateToPending, resetAllProgress } =
  useProgressBarActions();
const { paymentCallback } = usePaymentEndpoints();
const routedToPaymentOnce = false;

const routes = [
  {
    path: "/",
    name: "order",
    component: OrderView,
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: "/papi/transit/",
    name: "order.papi",
    component: OrderView,
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: "/verification",
    name: "verification",
    component: VerificationView,
    beforeEnter() {
      updateToPending("verification");
    },
  },
  {
    path: "/verification/code",
    name: "verificationCode",
    component: VerificationCodeView,
  },
  {
    path: "/payment/:payment",
    name: "payment.payment",
    component: PaymentView,
    async beforeEnter(to, from, next) {
      updateToComplete(["verification", "identity"]);
      updateToPending("payment");
      next();
    },
  },
  {
    path: "/payment/:payment/callback/:status",
    name: "payment.callback",
    component: PaymentView,
    beforeEnter(to, from, next) {
      paymentCallback(to, next);
    },
  },
  {
    path: "/coindeposit/*",
    name: "coindeposit",
    component: CoinDepositView,
    beforeEnter() {
      updateToComplete(["verification", "identity"]);
      updateToPending("payment");
    },
  },
  {
    path: "/deposit",
    name: "deposit",
    component: DepositView,
  },
  {
    path: "/coindeposit/:orderId",
    name: "coindeposit",
    component: CoinDepositView,
    beforeEnter() {
      updateToComplete(["verification", "identity"]);
      updateToPending("payment");
    },
  },
  {
    path: "/status/:orderId",
    name: "summary",
    component: OrderSummaryView,
    beforeEnter() {
      updateToComplete(["verification", "identity", "payment"]);
    },
  },
  {
    path: "/widget",
    name: "widget",
    component: WidgetView,
    beforeEnter() {
      resetAllProgress();
    },
  },
  {
    path: "/error",
    name: "error",
    component: ErrorView,
    props: (route) => ({ ...route.query }),
  },
  {
    path: '/:pathMatch(.*)*', // Updated catch-all route definition
    name: 'not-found',
    redirect: { name: 'error', query: { errorCode: '404'}}, // Redirect to the 'error' route
  },
  
];

export default routes;
